<template>
	<div>
		<div v-for="(option, okey) in options" :key="okey">
			<div class="row">
				<div class="col-4">
					<input name="optionvalue[]" class="form-control" v-model="option.value" :placeholder="$t('value')" />
				</div>
				<div class="col-4">
					<input name="optioncaption[]" class="form-control" v-model="option.caption" :placeholder="$t('caption')" />
				</div>
				<!--
				<div class="col-1">
				</div>
				-->
				<div class="col-4">
					<div style="display: inline-block">
						<BtnOnClassPicker :option="option" :okey="okey"></BtnOnClassPicker>
					</div>
					<a class="btn btn-light" @click="toggleInfo(option)" style="padding: 2px; margin-left: 2px;"><b-icon icon="info" width=".8em" height=".8em"></b-icon></a>
					<a class="btn btn-light" @click="removeOption(okey)" style="padding: 2px; margin-left: 2px;"><b-icon icon="trash" width=".8em" height=".8em"></b-icon></a>
				</div>
			</div>
			<div v-show="option.showinfo">
				<div class="form-group">
					<label>{{ $t("info") }}</label>
					<vue-editor v-model="option.info"></vue-editor>
					<!--
					<textarea v-model="option.info" class="form-control"></textarea>
					-->
				</div>
			</div>
		</div>
		<div v-if="!hideAddButton">
			<button class="btn btn-light" @click="addOption"><b-icon icon="plus" width="1em" height="1em"></b-icon> {{ $t('add-option') }}</button>
		</div>
	</div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import BtnOnClassPicker from "./BtnOnClassPicker";
export default {
	components: {
		VueEditor ,
		BtnOnClassPicker
	},
	name: 'OptionsEditor',
	props: {
		options: Array,
		// Hide the manual "add option" affordance - used when options are sourced from a
		// standardised response value group (question bank fields), where ad hoc additions
		// would defeat the point of standardisation.
		hideAddButton: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
		}
	},
	methods: { 	 
		addOption() {
			//if (field.options == undefined) field.options = [];
			this.$set(this.options, this.options.length, {
				value: '' ,
				caption: '',
				info: null,
				showinfo: false
			});
			this.$forceUpdate();
		},
		removeOption( optionIndex) {
			this.$delete(this.options, optionIndex);
			this.$forceUpdate();
		},
		toggleInfo(option) {
			option.showinfo = !option.showinfo;
		}	    	
	},
	computed: {

	}
};
</script>